import React, { useRef } from 'react';

import { ContentWrapper } from '../../../../components/ContentWrapper/ContentWrapper';
import { ModalType } from '../../../../components/ContentWrapper/Modal/Modal';
import { Fade } from '../../../../components/transitions/Fade';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { ResultContent } from './ResultContent';

interface ResultProps {
  totalQuestions: number;
  correctAnswers: number;
  successRate: number | null;
  onClose: (passed: boolean) => void;
}

export const Result: React.FC<ResultProps> = ({ totalQuestions, correctAnswers, successRate, onClose }) => {
  const ref = useRef(null);
  const isMobile = useIsMobile();
  return !isMobile ? (
    <Fade ref={ref}>
      <ContentWrapper>
        <ContentWrapper.Modal ref={ref} modalType={ModalType.small} blocking>
          <ResultContent
            total={totalQuestions}
            successful={correctAnswers}
            onClose={onClose}
            successRate={successRate}
          />
        </ContentWrapper.Modal>
      </ContentWrapper>
    </Fade>
  ) : (
    <ContentWrapper>
      <ContentWrapper.Modal>
        <ResultContent total={totalQuestions} successful={correctAnswers} onClose={onClose} successRate={successRate} />
      </ContentWrapper.Modal>
    </ContentWrapper>
  );
};
